import React from 'react';
import { Text, Title } from '@gjensidige/builders-components';
import './DiscountSection.scss';

interface DiscountSectionProps {
  discountsList: {
    "description": string;
    "title": string;
    "value": string;
  }[],
  totalYearlyDiscount: {
    label: string;
    value: string;
  };
  
}
export const DiscountSection: React.FC<DiscountSectionProps> = (
  {discountsList, totalYearlyDiscount}: DiscountSectionProps
) => {
  return (
    <div className="discount-section-wrapper">
      <div className="discount-details-section">
        {discountsList &&
          discountsList.length > 0 &&
          discountsList.map((discount, index) => (
            <div key={`discountKey${index}`}>
              {discount.title && (
                <div className="pb-1">
                  <div className="discount-item pt-1">
                    <Text size="body" className="discount-label">
                      {discount.title}{' '}
                    </Text>
                    <Text size="body" className="discount-value">{discount.value}</Text>
                  </div>
                  <div>
                    <Text size="body">{discount.description}</Text>
                  </div>
                </div>
              )}
            </div>
          ))}
        <div className="section-seperator"></div>

        <div className="discount-item py-1">
          <Text weight="700" size="body">{totalYearlyDiscount.label}</Text>
          <Text size="body" className="discount-value">{totalYearlyDiscount.value}</Text>
        </div>
      </div>
    </div>
  );
};
